import React, { useState, useEffect } from 'react';
import { db } from '../../../../firebase';
import { collection, query, orderBy, onSnapshot, limit } from 'firebase/firestore';
import './PoliceTab.css';

const PoliceTab = () => {
    const [downloadEvents, setDownloadEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Listen for photo download events
        const downloadEventsRef = collection(db, 'photo_downloads');
        const q = query(
            downloadEventsRef, 
            orderBy('timestamp', 'desc'), 
            limit(50)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const events = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                timestamp: doc.data().timestamp?.toDate() || new Date()
            }));
            setDownloadEvents(events);
            setLoading(false);
        }, (error) => {
            console.error('Error fetching download events:', error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const formatDate = (date) => {
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(date);
    };

    const getDeviceInfo = (userAgent) => {
        if (userAgent.includes('iPhone')) return 'iPhone';
        if (userAgent.includes('iPad')) return 'iPad';
        if (userAgent.includes('Android')) return 'Android';
        if (userAgent.includes('Windows')) return 'Windows';
        if (userAgent.includes('Mac')) return 'Mac';
        return 'Unknown';
    };

    const truncateText = (text, maxLength = 50) => {
        if (!text) return 'Unknown';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    if (loading) {
        return (
            <div className="police-tab">
                <h3>Police Dashboard</h3>
                <div className="loading-container">
                    <p>Loading download events...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="police-tab">
            <h3>Police Dashboard</h3>
            <p>Monitor photo downloads and user activity</p>
            
            <div className="police-stats">
                <div className="stat-card">
                    <h4>Total Downloads</h4>
                    <span className="stat-number">{downloadEvents.length}</span>
                </div>
                <div className="stat-card">
                    <h4>Unique Users</h4>
                    <span className="stat-number">
                        {new Set(downloadEvents.map(event => event.userId)).size}
                    </span>
                </div>
                <div className="stat-card">
                    <h4>Today's Downloads</h4>
                    <span className="stat-number">
                        {downloadEvents.filter(event => {
                            const today = new Date();
                            const eventDate = new Date(event.timestamp);
                            return eventDate.toDateString() === today.toDateString();
                        }).length}
                    </span>
                </div>
            </div>

            <div className="download-events">
                <h4>Recent Download Events</h4>
                {downloadEvents.length === 0 ? (
                    <div className="no-events">
                        <p>No download events recorded yet.</p>
                        <p>Events will appear here when users download photos from your galleries.</p>
                    </div>
                ) : (
                    <div className="events-list">
                        {downloadEvents.map(event => (
                            <div key={event.id} className="event-card">
                                <div className="event-header">
                                    <div className="user-info">
                                        <strong>{event.userEmail || event.userId}</strong>
                                        <span className="device">{getDeviceInfo(event.userAgent)}</span>
                                    </div>
                                    <div className="event-time">
                                        {formatDate(event.timestamp)}
                                    </div>
                                </div>
                                <div className="event-details">
                                    <p><strong>Photo:</strong> {truncateText(event.photoUrl, 40)}</p>
                                    <p><strong>Gallery:</strong> {truncateText(event.galleryName, 30)}</p>
                                    <p><strong>IP:</strong> {event.ipAddress || 'Unknown'}</p>
                                    <p><strong>Location:</strong> {truncateText(event.location, 30)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PoliceTab;
